module.exports = __webpack_public_path__ + "img/genesis-drop-impostor-5.e5b52b88.webp";